import { useEffect, useMemo } from "react";
import { useAppContext } from "../contexts/AppContext";
import { initGoogleAnalytics, parseMeasurementIds } from "../util/googleAnalytics";

const GoogleAnalytics: React.FC = () => {
    const { branding, deploymentMode } = useAppContext();

    const measurementIds = useMemo(
        () => parseMeasurementIds(branding?.googleAnalytics),
        [branding?.googleAnalytics]
    );

    useEffect(() => {
        initGoogleAnalytics(measurementIds, {
            debug: deploymentMode === "Development",
        });
    }, [measurementIds, deploymentMode]);

    return null;
};

export default GoogleAnalytics;
